import React, { useContext, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import OrderUserContext from "../OrderUserContext"; // Adjust the path to your ontext
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";

const OrderList = () => {
  const { customer } = useContext(OrderUserContext); // Access customer from context

  // Flatten all orders across customer
  const orders = customer.flatMap((item) =>
    item.orders.map((order) => ({
      ...order,
      name: item.name || order.deliveryAddress.name,
      customerEmail: item.email,
      customerPhoneNumber: item.phoneNumber,
      customerCreatedAt: item.createdAt,
    }))
  );

  // Pagination logic
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const currentOrders = orders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div className="all-products">
      <Container fluid>
        <div className="products-page-heading">
          <h1>Orders</h1>
        </div>
        <div
          className="all-product-list mb-1"
          style={{ height: "75vh", overflowY: "auto" }}
        >
          <TableContainer component={Paper}>
            <Table className="relative">
              <TableHead className="thead-box">
                <TableRow style={{ borderBottom: "2px solid gray" }}>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Order ID
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Customer
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Product Name
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Payment Method
                  </TableCell>
                  <TableCell
                    className="font-semibold"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentOrders.map((order, index) => (
                  <TableRow
                    key={index}
                    style={{
                      borderBottom: "1.5px solid gray",
                      backgroundColor: index % 2 === 0 ? "#f2f2f2" : "#ffffff", // Alternating colors
                    }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}.</TableCell>
                    <TableCell>
                      <Link to={`/order-details/${order.orderId}`} className="">
                        {order.orderId.toUpperCase()}
                      </Link>
                    </TableCell>
                    <TableCell>
                      {new Intl.DateTimeFormat("en-US", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }).format(new Date(order.createdAt))}
                    </TableCell>
                    <TableCell>{order.name}</TableCell>
                    <TableCell>
                      {order.products.map((product, idx) => (
                        <div key={idx} className="flex items-center">
                          <p className="text-sm leading-3">{product.title}</p>
                        </div>
                      ))}
                    </TableCell>
                    <TableCell>{order.paymentMethod}</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {order.products
                        .reduce(
                          (total, product) =>
                            total + product.originalPrice * product.quantity,
                          0
                        )
                        .toLocaleString("en-in", {
                          style: "currency",
                          currency: "INR",
                        })}
                      /-
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
<div></div>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={orders.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="actions"
            />
          </TableContainer>
        </div>
      </Container>
    </div>
  );
};

export default OrderList;
